import { IonButton, IonContent, IonPage } from '@ionic/react'
import React, { Component } from 'react'
import MainHeader from '../../components/headers/mainHeader'
import { Icon } from '@iconify/react'
import MainFooter from '../../components/mainFooter'
import config from '../../settings/config'
import dietaSocialLogo from '../../assets/images/ds-logo.svg'
import dietaSocialLogoSandbox from '../../assets/images/ds-logo-sandbox.svg'

// Some errors come from third-party analytics scripts (Facebook Pixel,
// Google Tag Manager, etc.) that monkey-patch browser APIs and
// occasionally throw runtime errors that have nothing to do with our
// app. The most common example: Meta's fbevents.js calls
// history.replaceState() so aggressively on Capacitor's capacitor://
// URL scheme that the browser hits its rate-limit of 100 calls per
// 10 seconds and throws a SecurityError. Letting these reach the
// fallback UI would block legitimate flows (e.g. post-purchase
// navigation to the goals tab), so we treat them as non-fatal: log
// them and let React continue rendering the real app.
const isThirdPartyAnalyticsError = (error) => {
	if (!error) return false

	const name = String(error.name || '')
	const message = String(error.message || '')
	const stack = String(error.stack || '')

	// The exact SecurityError thrown by Pixel's replaceState cascade.
	if (
		name === 'SecurityError' &&
		/replaceState/i.test(message)
	) {
		return true
	}

	// Generic match on the script origins we know inject patched
	// history APIs. Add more domains here as we discover them.
	const externalOriginPattern = /(connect\.facebook\.net|googletagmanager|google-analytics|gtag\/js)/i
	if (externalOriginPattern.test(stack)) {
		return true
	}

	return false
}

class ErrorBoundary extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hasError: false,
			error: null,
			errorInfo: null
		}
		this.userIsFullLogged =
			localStorage.getItem('adoc_t') && localStorage.getItem('adoc_p')
	}

	static getDerivedStateFromError(error) {
		// Don't flip into the fallback for known-third-party noise.
		// Returning null leaves state unchanged so the app keeps rendering.
		if (isThirdPartyAnalyticsError(error)) return null
		return { hasError: true, error }
	}

	componentDidCatch(error, errorInfo) {
		// Always log so we can see the noise in dev / Sentry. Only the
		// fallback UI is suppressed for third-party noise.
		console.error('Error caught by boundary:', error)
		console.error('Error stack:', error.stack)
		console.error('Component stack:', errorInfo.componentStack)

		if (isThirdPartyAnalyticsError(error)) {
			// Swallow: getDerivedStateFromError already kept hasError
			// at false, but React still calls componentDidCatch. Don't
			// store the error in state — that would cause an unnecessary
			// re-render with an error pinned to a working subtree.
			return
		}

		// Real app error — store for the dev-mode details panel.
		this.setState({
			error: error,
			errorInfo: errorInfo
		})
	}

	render() {
		if (this.state.hasError) {
			return (
				<IonPage>
					{this.state.userIsFullLogged && (
						<MainHeader
							page="ErrorPage"
							title="Errore"
						/>
					)}
					{!this.state.userIsFullLogged && (
						<img
							src={
								config.env.mode !== 'prod' && config.env.mode !== 'preprod'
									? dietaSocialLogoSandbox
									: dietaSocialLogo
							}
							alt="Dieta Social Logo"
							className="logo"
							style={{ maxWidth: '300px', margin: '100px auto 0 auto' }}
						/>
					)}

					<IonContent className="no-records ion-padding">
						<Icon
							style={{ marginTop: '70px' }}
							icon="iconoir:ev-plug-error"
							width="100"
						/>
						<h1>Ops! Abbiamo trovato un errore</h1>
						
						{/* Error details in development */}
						{config.env.mode !== 'prod' && this.state.error && (
							<div style={{ 
								textAlign: 'left', 
								margin: '20px', 
								padding: '10px',
								backgroundColor: '#f8f8f8',
								borderRadius: '5px',
								fontSize: '12px',
								overflow: 'auto',
								maxHeight: '200px'
							}}>
								<h3>Error Details:</h3>
								<pre>{this.state.error.toString()}</pre>
								{this.state.errorInfo && (
									<pre>{this.state.errorInfo.componentStack}</pre>
								)}
							</div>
						)}

						<IonButton color="primary">
							<a
								style={{
									margin: 0,
									padding: 0,
									textDecoration: 'none',
									color: 'white',
								}}
								href="../"
								className="ion-margin ion-color ion-color-primary md button button-solid ion-activatable ion-focusable">
								Torna
							</a>
						</IonButton>
					</IonContent>

					{this.state.userIsFullLogged && <MainFooter />}
				</IonPage>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
